import { ONBOARDING_STATUS } from '@realadvisor/constants';

export const isOnboardingPendingReview = (status: string | null | undefined) =>
  status === ONBOARDING_STATUS.pendingReview;
